import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IMenu } from 'src/app/shared/models';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit {

  activeIndex = 0;

  constructor(private router: Router) { }


  list: IMenu[] = [
    { title: 'Список', route: 'list' },
    { title: 'Добавить', route: 'add' },
  ];

  ngOnInit() {
    this.router.navigate(['main/users/list']);
  }
  selectList(i: number) {
    this.activeIndex = i;
  }

}

